function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import cf from 'clownface';
import deleteMatch from 'rdf-dataset-ext/deleteMatch';
import addAll from 'rdf-dataset-ext/addAll';
import TermMap from '@rdf-esm/term-map';
import ResourceRepresentationImpl from "./ResourceRepresentation.mjs";
import CachedResourceFactoryImpl from "./Resources/ResourceFactory.mjs";
import { tripleToQuad } from "./helpers/dataModel.mjs";
export default class ResourceStoreImpl {
  constructor({
    dataset,
    inferences,
    factory,
    datasetFactory
  }) {
    _defineProperty(this, "dataset", void 0);

    _defineProperty(this, "inferences", void 0);

    _defineProperty(this, "factory", void 0);

    _defineProperty(this, "rootNodes", new TermMap());

    _defineProperty(this, "responses", new TermMap());

    _defineProperty(this, "datasetFactory", void 0);

    this.dataset = dataset;
    this.inferences = inferences;
    this.factory = factory instanceof CachedResourceFactoryImpl ? factory : new CachedResourceFactoryImpl(factory);
    this.datasetFactory = datasetFactory;
  }

  clone() {
    return new ResourceStoreImpl({
      inferences: this.inferences,
      dataset: this.datasetFactory([...this.dataset]),
      factory: this.factory.clone(),
      datasetFactory: this.datasetFactory
    });
  }

  get(idOrPointer) {
    let graph;
    let node;

    if ('termType' in idOrPointer) {
      graph = idOrPointer;
      node = cf({
        dataset: this.dataset,
        graph
      });
    } else {
      graph = idOrPointer._context[0].graph;
      node = idOrPointer;
    }

    const response = this.responses.get(graph);

    if (!response) {
      return undefined;
    }

    const rootNode = this.rootNodes.get(graph) || graph;
    return {
      response,
      representation: new ResourceRepresentationImpl(node, this.factory, rootNode)
    };
  }

  async set(graph, {
    response,
    dataset,
    rootResource
  }) {
    this.factory.removeCache(graph);
    const inferredQuads = this.datasetFactory();
    this.inferences.forEach(inferenceOver => addAll(inferredQuads, [...inferenceOver(dataset)]));
    addAll(deleteMatch(this.dataset, undefined, undefined, undefined, graph), [...dataset].map(tripleToQuad(graph)));
    addAll(this.dataset, [...inferredQuads].map(tripleToQuad(graph)));
    this.responses.set(graph, response);

    if (rootResource) {
      this.rootNodes.set(graph, rootResource);
    }
  }

}